module.exports = __webpack_public_path__ + "static/img/share_ic1.bec0d8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sharedHome/share_ic1.png
// module id = v35Q
// module chunks = 1